// extracted by mini-css-extract-plugin
module.exports = {"agreementWrapper":"Agreement_agreementWrapper__XXSTJ","chapterContentWrapper":"Agreement_chapterContentWrapper__QbIFc"};